import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../services/api'

import styles from './styles.module.scss'

type ArticlesProps = {
    id: string;
}

type Artigo = {
    ID: number;
    CM_CAT_UNIVERSAL: number;
    CM_CAT_ID: string;
    CM_TITULO: string;
    CM_DESCRICAO: string;
    CM_CONTEUDO: string;
    CM_VISUALIZADA: null;
    CM_UTIL: null;
    CM_NAO_UTIL: null;
}

export function OpenArticle() {

    const [loading, setLoading] = useState(true)
    const [article, setArticle] = useState<Artigo>({} as Artigo)

    const { id } = useParams<ArticlesProps>()

    useEffect(() => {
        async function fetchData() {
            const result = await api.get(`/manuais/artigos/${id}`)
            setArticle(result.data[0])
        }

        fetchData()
        setLoading(false)
    }, [id])


    if (loading || !article) {
        return (

            <div className="loading">
                Carregando...
            </div>
        )
    }

    return (
        <>
            <div className={styles.contentContainer}>
                {/*<div className={styles.aticleHeaderContainer}>
                    <div className={styles.titleContainer}>
                        <h2>{article.CM_TITULO}</h2>
                    </div>
                    <div className={styles.descriptionContainer}>
                        <h2>{article.CM_DESCRICAO}</h2>
                    </div>
                </div> */}
                {/* <hr /> */}
                <div className={styles.articleContentContainer}>
                    <div className={styles.iframeContainer} dangerouslySetInnerHTML={{ __html: article.CM_CONTEUDO }} />
                </div>
                {/* <div className="autorContainer">
                        <h2>Autor: {data.CM_AUTOR}</h2>
                    </div> */}
            </div>
        </>
    )
}


